export const base = document.domain === 'localhost' ? '/api' : ''




// WEBPACK FOOTER //
// ./src/api/config.js